export const fixHref = (href:string)=>{
    if(href.includes("http://")||href.includes("https://")){
        return href
    }else{
        return ("http://"+href)
    }
}